// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_style_checkbox__nsQ5I","rotate":"Checkbox_style_rotate__ArSPy"};